<template>
  <div class="app-container bg-ff">
    <div class="flex align-center">
      <div class="btn-30-bg-82b925-big mr-10" @click="webapp({})">打印预览</div>
      <div class="btn-30-bg-f5971d mr-10" @click="webapp({'type':'print'})">打印</div>
      <div class="btn-30-border-30313a mr-10" @click="webapp({'type':'print', 'showOptionDlg': 'false'})">直接打印</div>
      <div class="btn-30-border-f5971d-s mr-10" @click="webapp({'type':'pdf'})">导出PDF</div>
      <div class="btn-30-bg-82b925-big mr-10" @click="webapp({'type':'xls'})">导出Excel</div>
      <div class="btn-30-bg-f5971d mr-10" @click="webapp({'type':'rtf'})">导出RTF</div>
      <div class="btn-30-border-f5971d-s mr-10" @click="webapp({'type':'csv'})">导出CSV</div>
      <div class="btn-30-border-30313a mr-10" @click="webapp({'type':'txt'})">导出文本</div>
      <div class="btn-30-bg-f5971d mr-10" @click="webapp({'type':'img'})">导出图像</div>
      <div class="btn-30-bg-82b925-big mr-10" @click="webapp({'type':'grd'})">生成报表文档</div>
    </div>
    <div class="flex-1 h-0">
      <el-scrollbar class="h-100">
        <div class="p-20">
          <div id="report_holder">
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import Grh from '@/utils/grhtml5-6.6-min.js'
import reportApi from '@/utils/grwebapp.js'
export default {
  name: 'reportDemo',
  components: {},
  data () {
    return {
      reportViewer: null,
      data: ''
    }
  },
  created () {
    this.reportViewer = Grh.rubylong.grhtml5.insertReportViewer('report_holder')
    this.reportViewer.dataPrepared = false // 指定报表生成需要加载报表数据
    let sqlStatement = ''
    let that = this
    Grh.rubylong.ajax({method: 'get', url: `${this.$store.state.API_URL_9010}/user/test`}, function (xmlhttp, success) {
      if (success) {
        // 获取查询语句
        console.log(xmlhttp.responseText)
        that.reportViewer.loadReport(xmlhttp.responseText)
        let jsonObj = JSON.parse(xmlhttp.responseText)
        sqlStatement = jsonObj.DetailGrid.Recordset.QuerySQL
        if (sqlStatement != null && sqlStatement !== '') {
          that.axios.post(`${this.$store.state.API_URL_9010}/user/getReportData`, that.qs.stringify({querySql: sqlStatement})).then(res => {
            that.data = res.data
            that.reportViewer.loadData(res.data)
            that.reportViewer.start()
            reportApi.webapp_urlprotocol_startup()
          })
        } // 判断QuerySQL是否为空结束
      }// if结束
    })
  },
  mounted () {},
  methods: {
    webapp (args) { // 运行WEB报表客户端实现打印、打印预览与数据导出功能
      args.scripts = [{
        event: 'Initialize'
      }]
      args.report = this.reportViewer.reportText
      args.data = this.reportViewer.dataText
      reportApi.webapp_ws_ajax_run(args)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/report/ReportDemo.vue